// Define UserRole type
export type UserRole = 'ADMIN' | 'USER';

// Define permissions
export const PERMISSIONS = {
  VIEW_ADMIN_DASHBOARD: 'VIEW_ADMIN_DASHBOARD',
  MANAGE_USERS: 'MANAGE_USERS',
  CREATE_SKILL: 'CREATE_SKILL',
  CREATE_ADAPTER: 'CREATE_ADAPTER'
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

// Role-based permissions mapping
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  ADMIN: [
    PERMISSIONS.VIEW_ADMIN_DASHBOARD,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.CREATE_SKILL,
    PERMISSIONS.CREATE_ADAPTER
  ],
  USER: [
    PERMISSIONS.CREATE_SKILL,
  ],
};

export interface User {
  email: string;
  sub: string;
  cognitoUsername: string;
  userId: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  profileImage?: string;
}

export interface SystemInfo {
  version: string;
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isAdmin: boolean;
  systemInfo: SystemInfo | null;
  signInWithGoogle: () => Promise<void>;
  handleOAuthCallback: (code: string) => Promise<boolean>;
  signOut: () => Promise<boolean>;
  getAuthToken: () => Promise<string | null>;
  setSystemInfo: (info: SystemInfo) => void;
  hasPermission: (permission: string) => boolean;
  checkAuthStatus: () => Promise<boolean>;
  refreshSession: () => Promise<boolean>;
}